import { Box, Button, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect } from 'react'
import { hideBodyOverflow } from '../utils/utils';

export default function Privacy ({privacyIsOpen, closeContactForm, closePrivacy}) {

  useEffect(() => {
    hideBodyOverflow(privacyIsOpen)
  }, [privacyIsOpen])
  return (
    privacyIsOpen && (
      <Box sx={{ overflowY:'scroll', position:'fixed', top:'0', left:'0', maxHeight:'100vh', width:'100%', height:'100%', bgcolor:'white', zIndex:'5000',flexDirection:'column', display:'flex',  alignItems:'center'}}>
        <IconButton 
        sx={{
            position:{xs:'static', md:'absolute'}, 
            width:'40px', 
            top:'5%', 
            right:'5%',
            marginTop:'1rem', 
            height:'40px', 
            backgroundColor:'white',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            marginBottom:'1rem',
            
        }}
        size='small'
        color='primary'
        variant="outlined" 
        label="close"
        onClick={closePrivacy}
        >
            
            <CloseIcon id='close-icon' sx={{color:'black'}}/>
            </IconButton>
        <Typography variant="h4" color="text.primary" sx={{textAlign:'center', margin:'3rem 0rem 3rem 0rem', fontWeight:'800' }}>Politique de confidentialité</Typography>
        <hr style={{width:'70%', height:'3px', color:'red'}}/>  
        <Box sx={{mt:'2rem', mb:'6rem', width:'85%', textAlign:'justify', display:'flex', flexDirection:'column', justifyContent:'center' , alignItems:'center' }}>
          <Box className="member_wrapper">
          <Box sx={{fontSize:'12px'}}className="privacy_body">
  <div><strong>Introduction</strong></div>
  <div>
    Devant le développement des nouveaux outils de communication, il est nécessaire de porter une attention particulière à la protection de la vie privée. C’est pourquoi, nous nous engageons à respecter la confidentialité des renseignements personnels que nous collectons.
  </div>
  <div><br /></div>
  <h2>Collecte des renseignements personnels</h2>
  <div><br /></div>
  <div>
    <ul>
      <li>Prénom</li>
      <li>Adresse électronique</li>
      <li>Numéro de téléphone / télécopieur</li>
    </ul>
  </div>
  <div>
    Les renseignements personnels que nous collectons sont recueillis au travers de formulaires et grâce à l’interactivité établie entre vous et notre site Web. Nous utilisons également, comme indiqué dans la section suivante, des fichiers témoins et/ou journaux pour réunir des informations vous concernant.
  </div>
  <div><br /></div>
  <h2>Formulaires et interactivité:</h2>
  <div>Vos renseignements personnels sont collectés par le biais de formulaire, à savoir :</div>
  <div><br /></div>
  <div>
    <ul>
      <li>Formulaire d'inscription au site Web</li>
    </ul>
  </div>
  <div>Nous utilisons les renseignements ainsi collectés pour les finalités suivantes :</div>
  <div><br /></div>
  <div>
    <ul>
      <li>Informations / Offres promotionnelles</li>
      <li>Contact</li>
    </ul>
  </div>
  <div>
    Vos renseignements sont également collectés par le biais de l’interactivité pouvant s’établir entre vous et notre site Web et ce, de la façon suivante:
  </div>
  <div><br /></div>
  <div>
    <ul></ul>
  </div>
  <div>Nous utilisons les renseignements ainsi collectés pour les finalités suivantes :</div>
  <div><br /></div>
  <div>
    <ul>
      <li>Contact</li>
    </ul>
  </div>
  <div><br /></div>
  <h2>Droit d’opposition et de retrait</h2>
  <div>Nous nous engageons à vous offrir un droit d’opposition et de retrait quant à vos renseignements personnels.</div>
  <div>Le droit d’opposition s’entend comme étant la possiblité offerte aux internautes de refuser que leurs renseignements personnels soient utilisées à certaines fins mentionnées lors de la collecte.</div>
  <div><br /></div>
  <div>Le droit de retrait s’entend comme étant la possiblité offerte aux internautes de demander à ce que leurs renseignements personnels ne figurent plus, par exemple, dans une liste de diffusion.</div>
  <div><br /></div>
  <div><strong>Pour pouvoir exercer ces droits, vous pouvez :</strong></div>
  <div><br /></div>
  <div></div>
  <div>Courriel : privacy@243studio.me</div>
  <div></div>
  <div></div>
  <div><br /></div>
  <h2>Droit d’accès</h2>
  <div>Nous nous engageons à reconnaître un droit d’accès et de rectification aux personnes concernées désireuses de consulter, modifier, voire radier les informations les concernant.</div>
  <div><br /></div>
  <div><strong>L’exercice de ce droit se fera :</strong></div>
  <div><br /></div>
  <div></div>
  <div>Courriel : privacy@243studio.me</div>
  <div></div>
  <div></div>
  <div><br /></div>
  <h2>Sécurité</h2>
  <div>Les renseignements personnels que nous collectons sont conservés dans un environnement sécurisé. Les personnes travaillant pour nous sont tenues de respecter la confidentialité de vos informations.</div>
  <div><br /></div>
  <div>Pour assurer la sécurité de vos renseignements personnels, nous avons recours aux mesures suivantes :</div>
  <div><br /></div>
  <div>
    <ul>
      <li>Protocole SSL</li>
      <li>Gestion des accès - personne autorisée</li>
      <li>Sauvegarde informatique</li>
      <li>Identifiant / mot de passe</li>
    </ul>
  </div>
  <div>
    Nous nous engageons à maintenir un haut degré de confidentialité en intégrant les dernières innovations technologiques permettant d’assurer la confidentialité de vos transactions. Toutefois, comme aucun mécanisme n’offre une sécurité maximale, une part de risque est toujours présente lorsque l’on utilise Internet pour transmettre des renseignements personnels.
  </div>
  <div><br /></div>
  <h2>Législation</h2>
  <div>Nous nous engageons à respecter les dispositions législatives énoncées dans :</div>
  <div><br /></div>
  <div>Législation: <b>243 Studio by WEPO RDC</b></div>
  <div><br /></div>
                  </Box>
              </Box>
            <Button variant="contained" sx={{bgcolor:'#007FFF', mt:'2rem', position:'fixed', bottom:'1rem'}}onClick={closePrivacy}>J'accepte</Button>
            </Box>
    </Box>)
  )
}
